import { render, staticRenderFns } from "./personal-center.vue?vue&type=template&id=272bde05&scoped=true"
import script from "./personal-center.vue?vue&type=script&lang=ts"
export * from "./personal-center.vue?vue&type=script&lang=ts"
import style0 from "./personal-center.vue?vue&type=style&index=0&id=272bde05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272bde05",
  null
  
)

export default component.exports